export enum DesignDialogNodeType {
  input = 'input',
  prompt = 'prompt',
  system = 'system'
}
